document.addEventListener('DOMContentLoaded', () => {
    let isInitializing = true;

    /**
     * Öffnet ein Accordion basierend auf dem URL-Hash
     */
    const openAccordionFromHash = () => {
        const hash = window.location.hash.substring(1);
        if (!hash) return;

        const targetHeader = document.getElementById(hash);
        if (!targetHeader) return;

        // Bei Details-Element das übergeordnete details-Element finden
        const detailsElement = targetHeader.closest('details');
        if (!detailsElement) return;

        const accordionGroup = detailsElement.closest('[data-accordion-group]');
        if (!accordionGroup) return;

        // Schließe alle Accordions in der Gruppe, wenn nicht mehrere gleichzeitig geöffnet sein dürfen
        if (accordionGroup.dataset.allowMultiple !== 'true') {
            closeAllAccordionsInGroup(accordionGroup);
        }

        // Öffne das Ziel-Accordion
        detailsElement.open = true;
        targetHeader.setAttribute('aria-expanded', 'true');

        // Scroll zum geöffneten Accordion
        targetHeader.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    /**
     * Schließt alle Accordions in einer Gruppe
     */
    const closeAllAccordionsInGroup = (accordionGroup) => {
        const detailsElements = accordionGroup.querySelectorAll('details');
        detailsElements.forEach(details => {
            details.open = false;
            const header = details.querySelector('[data-accordion-header]');
            if (header) {
                header.setAttribute('aria-expanded', 'false');
            }
        });
    };

    /**
     * Erstellt und fügt die Schließen und Öffnen Buttons hinzu
     */
    const addControlButtons = (accordionGroup) => {
        const wrapper = document.createElement('div');
        wrapper.className = 'accordion-controls';

        const closeAllBtn = document.createElement('button');
        closeAllBtn.type = 'button';
        closeAllBtn.innerText = 'Alle schließen';
        closeAllBtn.className = 'accordion-close-all';
        closeAllBtn.setAttribute('aria-label', 'Alle Accordion-Elemente dieser Gruppe schließen');
        closeAllBtn.addEventListener('click', () => {
            closeAllAccordionsInGroup(accordionGroup);
            // Hash entfernen
            history.pushState("", document.title, window.location.pathname + window.location.search);
        });

        const openAllBtn = document.createElement('button');
        openAllBtn.type = 'button';
        openAllBtn.innerText = 'Alle öffnen';
        openAllBtn.className = 'accordion-open-all';
        openAllBtn.setAttribute('aria-label', 'Alle Accordion-Elemente dieser Gruppe öffnen');
        openAllBtn.addEventListener('click', () => {
            const detailsElements = accordionGroup.querySelectorAll('details');
            detailsElements.forEach(details => {
                details.open = true;
                const header = details.querySelector('[data-accordion-header]');
                if (header) {
                    header.setAttribute('aria-expanded', 'true');
                }
            });
        });

        wrapper.appendChild(openAllBtn);
        wrapper.appendChild(closeAllBtn);

        accordionGroup.insertAdjacentElement('beforebegin', wrapper);
    };

    /**
     * Initialisiert ein einzelnes Accordion
     */
    const initializeAccordion = (detailsElement, index, allDetails, allowMultiple, openFirst) => {
        const header = detailsElement.querySelector('[data-accordion-header]');
        if (!header) return;

        // Initial-Zustand synchronisieren: Erstes Accordion offen, alle anderen geschlossen
        if (index === 0 && openFirst === 'true') {
            detailsElement.open = true;
            header.setAttribute('aria-expanded', 'true');
        } else {
            detailsElement.open = false;
            header.setAttribute('aria-expanded', 'false');
        }

        // Event-Handler für das details-Element
        detailsElement.addEventListener('toggle', () => {
            // aria-expanded aktualisieren
            header.setAttribute('aria-expanded', detailsElement.open ? 'true' : 'false');

            // Wenn nicht mehrere gleichzeitig geöffnet sein dürfen und dieses gerade geöffnet wurde
            if (!allowMultiple && detailsElement.open) {
                allDetails.forEach(otherDetails => {
                    if (otherDetails !== detailsElement) {
                        otherDetails.open = false;
                        const otherHeader = otherDetails.querySelector('[data-accordion-header]');
                        if (otherHeader) {
                            otherHeader.setAttribute('aria-expanded', 'false');
                        }
                    }
                });
            }

            // Füge ID zur URL hinzu, wenn geöffnet
            // if (detailsElement.open) {
            //     const headerId = header.id;
            //     if (headerId) {
            //         history.pushState(null, '', `${window.location.pathname}#${headerId}`);
            //     }
            // }
        });
    };

    // Initiale Verarbeitung aller Accordion-Gruppen
    const accordionGroups = document.querySelectorAll('[data-accordion-group]');
    accordionGroups.forEach(accordionGroup => {
        const allowMultiple = accordionGroup.dataset.allowMultiple === 'true';
        const openFirst = accordionGroup.dataset.openFirst;
        const showControls = accordionGroup.dataset.showControls === 'yes';

        // "Alle schließen/öffnen" Buttons hinzufügen, wenn erforderlich
        if (showControls) {
            addControlButtons(accordionGroup);
        }

        // Initialisiere alle Accordion-Details in dieser Gruppe
        const detailsElements = Array.from(accordionGroup.querySelectorAll('details'));
        detailsElements.forEach((details, index) => {
            initializeAccordion(details, index, detailsElements, allowMultiple, openFirst);
        });
    });

    // Initialisiere einzelne Accordion-Elemente außerhalb einer Gruppe
    const standaloneDetails = Array.from(document.querySelectorAll('details'))
        .filter(details => !details.closest('[data-accordion-group]'));

    standaloneDetails.forEach((details, index) => {
        initializeAccordion(details, index, standaloneDetails, true, 'true'); // allowMultiple: true, openFirst: true
    });

    // Hash-basierte Initialisierung
    openAccordionFromHash();
    // Verzögerung für Hash-Verarbeitung bei Navigation von anderen Seiten
    setTimeout(openAccordionFromHash, 100);
    // Event-Listener für Hash-Änderungen
    window.addEventListener('hashchange', openAccordionFromHash);
});